export default __webpack_public_path__ + "static/005-06c4a0c071071518234c4c87ed916742.jpg";